import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.less']
})

export class TermsAndConditionsComponent {

  constructor(private router: Router) {
  }

  goBack(): void {
    this.router.navigate(['criarConta']);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/terms-and-conditions/terms-and-conditions.component.ts